import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  BooleanInput,
} from 'react-admin'
import AutocompleteReferenceInput from '../AutocompleteReferenceInput'
import validateExists from '../../validators/validateExists'
import ImageUploadInput from '../common/ImageUploadInput'

const AppCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <AutocompleteReferenceInput
        source='organization_id'
        reference='organization'
        optionText='name'
        label='Organization'
      />
      <TextInput
        source='name'
        validate={[required(), validateExists(props, 'name')]}
      />
      <BooleanInput source='show_in_account_creation' defaultValue={false} />
      <ImageUploadInput source='logo_url' label='Logo' />
    </SimpleForm>
  </Create>
)

export default AppCreate
